import { render, staticRenderFns } from "./CompanyTableAvatar.vue?vue&type=template&id=7737cdf2&scoped=true"
import script from "./CompanyTableAvatar.vue?vue&type=script&lang=js"
export * from "./CompanyTableAvatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7737cdf2",
  null
  
)

export default component.exports